export default "__VITE_ASSET__5jxwM_FF__"